import * as auditLogActions from '../actions/audit_logs';

const initialState = {
    isLoadingLogs: false,
    isLogsInitialised: false,
    isMoreLogsToLoad: true,
    logs: []
};

export default (state = initialState, action) => {
    switch (action.type) {

        case auditLogActions.AUDIT_LOGS_RECEIVED:
            return {
                ...state,
                logs: [...state.logs, ...action.logs],
                isMoreLogsToLoad: action.isMoreLogsToLoad,
                isLogsInitialised: true
            };

        case auditLogActions.AUDIT_LOGS_LOADING_CHANGED:
            return {
                ...state,
                isLoadingLogs: action.isLoading
            };

        case auditLogActions.AUDIT_LOGS_RESET:
            return {
                ...initialState
            };

        default:
            return state;
    }
};